var _defs, _g, _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermPeriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#05f;}.c{fill:#04c;}.d{fill:#fff;}.e{fill:#ff6b00;}.f{opacity:.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.52,236.7c0-3.67,2.99-6.65,6.65-6.65h93.07c3.66,0,6.65,2.98,6.65,6.65v50.39c0,6.65-13.5,14.56-20.14,14.03-17.62-1.4-44.74,3.06-78.71,7.71-3.99,.53-7.51-2.59-7.51-6.58v-65.55Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 289.89,
    cy: 283.24,
    r: 59.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M230.06,310.96h-46.54c-12.83,0-23.27-10.44-23.27-23.27v-104.18c0-1.84,1.49-3.32,3.32-3.32h51.92c4.97,0,9.63,2.2,12.8,6.04l12.43,15.01h82.41c1.84,0,3.32,1.49,3.32,3.32v22.17c0,1.84-1.49,3.32-3.32,3.32s-3.32-1.49-3.32-3.32v-18.84h-80.65c-.99,0-1.93-.44-2.56-1.21l-13.43-16.21c-1.91-2.31-4.71-3.63-7.68-3.63h-48.6v100.85c0,9.17,7.45,16.62,16.62,16.62h46.54c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M213.44,205.68h-28.79c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h28.79c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M250,426.18c-.57,0-1.15-.15-1.66-.45l-149.72-86.43c-1.03-.59-1.66-1.69-1.66-2.88V163.57c0-1.19,.64-2.29,1.66-2.88L248.34,74.27c1.03-.6,2.3-.6,3.32,0l149.71,86.43c1.03,.59,1.66,1.69,1.66,2.88v172.85c0,1.19-.64,2.29-1.66,2.88l-149.71,86.43c-.51,.3-1.09,.45-1.66,.45Zm-146.4-91.67l146.4,84.51,146.39-84.51V165.5L250,80.98,103.61,165.5v169.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M234.84,284.04c0,1.8,1.53,3.26,3.39,3.26s3.26-1.53,3.26-3.39l-6.65,.13Zm11.1,21.87c-1.8-.47-3.59,.6-4.06,2.39l-7.71,28.85c-.47,1.8,.6,3.59,2.33,4.12,1.8,.47,3.59-.6,4.06-2.39l6.91-25.66,25.66,6.85c1.8,.47,3.59-.6,4.06-2.39,.47-1.73-.53-3.59-2.33-4.06l-28.92-7.71Zm78.98,10.7c-18.42,19.35-49.06,20.08-68.41,1.66l-4.59,4.85c22.01,20.94,56.84,20.08,77.85-1.93l-4.85-4.59Zm-70.07-66.76c18.42-19.35,49.06-20.1,68.41-1.66l4.59-4.81c-22.01-20.98-56.84-20.13-77.85,1.88l4.85,4.59Zm68.41-1.66c19.35,18.44,20.08,49.07,1.66,68.42l4.85,4.59c20.94-22.01,20.08-56.85-1.93-77.82l-4.59,4.81Zm-81.77,35.71c-.2-12.21,4.25-24.5,13.36-34.05l-4.85-4.59c-10.31,10.86-15.36,24.86-15.16,38.77l6.65-.13Zm15.03,34.37c-3.46-3.26-6.32-6.91-8.51-10.84l-5.78,3.39c2.59,4.39,5.78,8.58,9.71,12.3l4.59-4.85Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 285.96,
    y: 229.91,
    width: 6.65,
    height: 13.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 285.96,
    y: 324.46,
    width: 6.65,
    height: 13.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 329.18,
    y: 279.77,
    width: 13.3,
    height: 6.65
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M289.29,293.48c-.84,0-1.65-.32-2.27-.9l-20.67-19.31c-1.34-1.25-1.41-3.36-.16-4.7,1.26-1.33,3.36-1.4,4.7-.16l17.96,16.79,24.37-32.47c1.1-1.46,3.19-1.77,4.65-.66,1.47,1.1,1.77,3.18,.66,4.65l-26.59,35.43c-.56,.76-1.42,1.23-2.36,1.32-.1,0-.19,.01-.29,.01Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 289.89,
    cy: 287.23,
    r: 6.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M289.89,297.21c-5.5,0-9.97-4.47-9.97-9.97s4.47-9.97,9.97-9.97,9.97,4.47,9.97,9.97-4.47,9.97-9.97,9.97Zm0-13.3c-1.83,0-3.32,1.49-3.32,3.32s1.49,3.32,3.32,3.32,3.32-1.49,3.32-3.32-1.49-3.32-3.32-3.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermPeriod);
export default __webpack_public_path__ + "static/media/term_period.30c1a8a48d915bed909200f039f37e04.svg";
export { ForwardRef as ReactComponent };